import CityPageTemplate from "../city-template/CityPageTemplate";
import { merrillvilleConfig } from "./data";

export default function MerrillvillePage() {
  return <CityPageTemplate config={merrillvilleConfig} />;
}